export default "__VITE_ASSET__743d239c__"